import { BaseChanceGameData, GreenFishChanceGameData, FishFoodChanceGameData, RedFishChanceGameData, PurpleFishChanceGameData, GoldFishChanceGameData } from "../../data/ChanceGamesData";
import { featureTypeFromChanceGameConfigIdStrict } from "./featureTypeFromChanceGameConfigId";
import { FeatureType } from "../../GameModel";
export function unpackChanceGameData(chanceGameData) {
    if (!chanceGameData) {
        return;
    }
    let chanceGame = new BaseChanceGameData(chanceGameData);
    const featureType = featureTypeFromChanceGameConfigIdStrict(chanceGame.getGameConfigId());
    switch (featureType) {
        case FeatureType.GREEN_FISH:
            chanceGame = new GreenFishChanceGameData(chanceGameData);
            break;
        case FeatureType.FISH_FOOD:
            chanceGame = new FishFoodChanceGameData(chanceGameData);
            break;
        case FeatureType.RED_FISH:
            chanceGame = new RedFishChanceGameData(chanceGameData);
            break;
        case FeatureType.PURPLE_FISH:
            chanceGame = new PurpleFishChanceGameData(chanceGameData);
            break;
        case FeatureType.GOLD_FISH:
            chanceGame = new GoldFishChanceGameData(chanceGameData);
            break;
    }
    return chanceGame;
}
//# sourceMappingURL=unpackChanceGameData.js.map